export interface SptBreakpoints {
  SMALL: string;
  LARGE: string;
}
